export default defineNuxtRouteMiddleware((to) => {
  const isCraftPreview = 'x-craft-live-preview' in to.query || 'x-craft-preview' in to.query

  if (to.path === '/homepage' && !isCraftPreview) {
    return navigateTo('/')
  }
})
